import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { Switch, Route } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';

import InsuranceEventSummary from 'containers/InsuranceEventSummary';
import dealsActions from '../../redux/deals/actions';
import dealersActions from '../../redux/dealers/actions';
import groupActions from '../../redux/groups/actions';
import * as analyticsActions from '../../redux/analytics/actions';
import SidebarContainer from '../SidebarContainer';
import InternalDashboardNav from '../../components/InternalDashboardNav';
import Deals from '../Deals';
import PrivateRoute from '../PrivateRoute';
import DealerStatus from '../DealerStatus';
import LendingResults from '../LendingResults';
import LendingStatus from '../LendingStatus';
import './InternalDashboard.scss';
import { UpstartAllLoanStatus } from '../UpstartLoanStatus/UpstartAllLoanStatus';

function InternalDashboard(props) {
  // if no section is set, redirect to the deals tab
  const { match, history } = props;
  useEffect(() => {
    if (!match.params.section) {
      history.replace(match.path.replace(':section?', 'deals/'));
    }
  }, [match, history]);

  return (
    <SidebarContainer title="Internal Dashboard">
      <div className="internal-dashboard-table">
        <InternalDashboardNav />
        <div className="internal-dashboard-container">
          <QueryParamProvider ReactRouterRoute={Route}>
            <Switch>
              <PrivateRoute
                path={`${props.match.path}/deals/`}
                component={Deals}
                componentProps={props}
              />
              <PrivateRoute
                path={`${props.match.path}/insurance-results/`}
                component={InsuranceEventSummary}
                componentProps={props}
              />
              <PrivateRoute
                path={`${props.match.path}/dealer-status/`}
                component={DealerStatus}
                componentProps={props}
              />
              <PrivateRoute
                path={`${props.match.path}/lending-results/`}
                component={LendingResults}
                componentProps={props}
              />
              <PrivateRoute
                path={`${props.match.path}/launch-status/`}
                component={LendingStatus}
                componentProps={props}
              />
              <PrivateRoute
                path={`${props.match.path}/loan-status/`}
                component={UpstartAllLoanStatus}
                componentProps={props}
              />
            </Switch>
          </QueryParamProvider>
        </div>
      </div>
    </SidebarContainer>
  );
}

InternalDashboard.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
};

const mapStateToProps = ({ deals, dealers, analytics, groups }) => ({
  deals,
  dealers,
  analytics,
  groups,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...dealsActions,
      ...dealersActions,
      ...analyticsActions,
      ...groupActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(InternalDashboard);
